
const areaList = [
  { name: '전체', latitude: 37.557012, longitude: 126.801263, zoom: 9 },
  { name: '서울', latitude: 37.548502, longitude: 126.9917825, zoom: 11 },
  { name: '인천', latitude: 37.4473332, longitude: 126.6438837, zoom: 12 },
  { name: '경기', latitude: 37.557012, longitude: 126.801263, zoom: 9 },
  { name: '강원', latitude: 37.8349547, longitude: 127.9917698, zoom: 10 },
  {
    name: '대전·충남북',
    latitude: 36.6163171,
    longitude: 126.9256068,
    zoom: 10,
  },
  {
    name: '광주·전남북',
    latitude: 35.2766365,
    longitude: 126.6069618,
    zoom: 10,
  },
  { name: '대구·경북', latitude: 35.8797296, longitude: 128.4964886, zoom: 10 },
  {
    name: '부산·울산·경남·제주',
    latitude: 34.4245493,
    longitude: 126.780594,
    zoom: 10,
  },
];

export const getAreaList = () => areaList;
